<template>
  <div class="v-container">
    <img :src="img.fields.file.url">
    <div class="side-container"> <div class="content">
      <h2>{{ event.title }}</h2>
      <p><strong>{{ date }}</strong></p>
      <p><small>{{ event.address }}</small></p>
    </div>
      <div
        class="cta"
        v-if="event.helloassoEventLink"><a
          :href="event.helloassoEventLink"
          rel="noopener noreferrer"
          target="_blank"
          class="button is-primary">S'inscrire</a></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cta {
  display: flex;
  justify-content: flex-end;
  a {
    text-decoration: none;
  }
}
.v-container {
  margin-bottom: 1em;
  display: flex;
  height: 250px;
  img {
    width: 300px;
    object-fit: cover;
  }
}
@media screen and (max-width: 600px) {
  .v-container {
    height: inherit;
    display: flex;
    flex-direction: column;
    img {
      object-fit: cover;
      width: 100%;
      height: 250px;
      margin-bottom: 1em;
    }
    .side-container {
      padding-left: 0;
    }
  }
}
.side-container {
  flex-grow: 1;
  padding-left: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
<script>
import moment from "moment";
import { getAsset } from "../../utils/contentful";
export default {
  name: "EventHeader",
  props: { vuexApiData: Object },
  computed: {
    img: function() {
      return getAsset(
        this.vuexApiData.includes,
        this.vuexApiData.items[0].fields.coverImage.sys.id
      );
    },
    event: function() {
      return this.vuexApiData.items[0].fields;
    },
    date: function() {
      return `${moment(this.event.dateStarted).format("MMMM Do YYYY")} ${moment(
        this.event.dateStarted
      ).format("HH:mm")} - ${moment(this.event.dateEnded).format("HH:mm")}`;
    }
  }
};
</script>
